import Popover from "@storeblocks/popover";
import { Partner } from "Store/partners/partnerInterfaces";
import styled from "styled-components";

export interface ThemedPopoverProps {
  partnerId: Partner;
}

export const ThemedPopover = styled(Popover)<ThemedPopoverProps>`
  height: 24px;
  width: 28px;

  & > button > i {
    color: ${({ partnerId }) => {
      switch (partnerId) {
        case Partner.COOP:
        case Partner.HUSEIERNE:
          // return "#fff";
          return "var(--p-color-text-primary)";
        default:
          return "#000";
      }
    }};
  }
`;
